import { isNumber, isEmpty } from 'lodash';

export const resources = {
  fieldIsRequired: 'This field is required.',
  invalidIban: 'Please enter a valid IBAN (e.g. 2 letters, 2 digits, then country-specific format).',
};

/**
 * Validates IBAN format and mod-97 checksum (ISO 13616). No external dependency.
 * - 2 letters (country) + 2 digits (check) + 11–30 alphanumeric (BBAN); total 15–34.
 * - Accepts input with or without spaces.
 */
function isValidIBAN(value) {
  const s = String(value).replace(/\s/g, '').toUpperCase();
  if (!/^[A-Z0-9]{15,34}$/.test(s) || !/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(s)) {
    return false;
  }
  const rearranged = s.slice(4) + s.slice(0, 4);
  let digits = '';
  for (let i = 0; i < rearranged.length; i++) {
    const c = rearranged[i];
    digits += /[A-Z]/.test(c) ? (c.charCodeAt(0) - 55).toString() : c;
  }
  let remainder = 0;
  for (let i = 0; i < digits.length; i++) {
    remainder = (remainder * 10 + parseInt(digits[i], 10)) % 97;
  }
  return remainder === 1;
}

export const validators = {
  resources,
  positive(value) {
    if (value < 0) {
      return ['Requires a positive value'];
    }
    return true;
  },
  numeric(value, required) {
    if (typeof value != "string") {
      if (!isNumber(value)) {
        return ['Must be a number'];
      }
    }
    if (!isNaN(value) &&
      !isNaN(parseFloat(value))) {
      return true;
    }

    return ['Must be a number'];
  },
  selectRequired(value) {
    if (value && value.id > 0) {
      return true;
    }

    return ['Please select a value'];
  },
  selectRequiredUuid(value) {
    if (value && value.id) {
      return true;
    }

    return ['Please select a value'];
  },
  fileTypes(value) {

  },
  checkEmptyInput(value) {
    if (isEmpty(value.trim())) {
      return ["Input cannot be empty."]
    } else {
      return []
    }
  },
  /**
   * Validates IBAN format and mod-97 checksum (ISO 13616).
   * Accepts input with or without spaces.
   */
  iban(value) {
    if (value == null || String(value).trim() === '') {
      return true;
    }
    if (!isValidIBAN(String(value).trim())) {
      return [resources.invalidIban];
    }
    return true;
  },
};

export const validateFileType = (filetypes) => (value) => {
  if (!value) {
    return;
  }

  const name = value.name;
  const hasExtension = (FileName, extensions) =>
      (new RegExp('(' + extensions.join('|').replace(/\./g, '\\.') + ')$')).test(FileName.toLowerCase())

  if (!hasExtension(name, filetypes)) {
    return 'File type must be any of the following: '+filetypes.join(', ');
  }

  return true;
}


export default validators;
